<template lang="pug">
  .mb-3
    label.form-label {{label}}
    select.form-select(:value="value" :class="classmethod" @input="onChange($event)" :required="required?true:false")
      option(value="", hidden) --- select ---
      option(v-for="option in options" :value="option[item.value]?option[item.value]:option") {{option[item.label]?option[item.label]:option}}
    form_error(:errors="errors?errors[name]:[]")
</template>

<script>
import formError from './formErrors';
import { mapState } from 'vuex';
export default {
  components: {
    form_error: formError,
  },
  props: {
    name:{
      type: String
    },
    label:{
      type: String
    },
    value:{
      type: String,
      default: ''
    },
    options:{

    },
    item:{
      type: Object,
      default: function(){
        return {
          value: "value",
          label: "label"
        }
      }
    },
    required:{
      type: Boolean,
      default: false,
    }
  },
  computed:{
    classmethod(){
      var errorclass = this.errors?this.errors[name]?'is-invalid':'':'';
      return errorclass;
    },
    ...mapState('api', ['errors'])
  },
  methods: {
    onChange(e){
      this.$emit('input', e.target.value[this.item.value]?e.target.value[this.item.value]:e.target.value)
    }
  }
}
</script>